import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ApiService from "../../services/ApiService";
import { toast } from "react-toastify";
import Paginator from "../../components/Paginator"; 

const AllTests = () => {
  const [tests, setTests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({});
  const [apiData, setApiData] = useState({
        search: "",
        page: 1,
  });

  useEffect(() => {
    fetchTests();
  }, [apiData.page, apiData.search]);

  const fetchTests = async () => {
    try {
        setLoading(true);
        const response = await ApiService.request({
            method: "GET",
            url: "getAllTests", 
            params: apiData
        });
        const data = response.data;
        
        if (data && data.status === true) {
          setTests(data.data);
          setPagination(data.pagination);

        } else {
          toast.error(data.message || "Failed to fetch interviews.");
        }
    } catch (err) {
      toast.error("Failed to fetch interviews.");
    } finally {
      setLoading(false);
    }
  };
  const handlePageChange = (event) => {
    setApiData(prev => ({ ...prev, page: event }));
  };

  return (
    <div className="container mt-4 allTestsHeading">
      <div className="d-flex justify-content-between align-items-center rounded estate-search-bar mt-5">
        <h5 className="p-3 bg-white w-100">All Tests</h5> 
      </div>

      <div className="bg-white p-4 mt-3">
        <div className="row">
          <div className="col-md-5 mb-3">
            <input type="search" name="search"  value={apiData.search} onChange={e => setApiData({ ...apiData, search: e.target.value })} className="form-control" placeholder="Search title..." />
          </div>
        </div>
        {loading ? (
          <div className="text-center">
            <span  class="spinner-border spinner-border-sm"
              role="status"  aria-hidden="true" ></span>
            <span class="sr-only mx-2">Loading...</span>
          </div>
            
        )  : (
          <div className="table-responsive tableOfTests">
            <table className="table table-bordered table-striped">
              <thead className="table-light">
                <tr>
                  <th>Title</th>
                  <th>Total Sections</th>
                  <th>Total Questions</th>
                  <th>My Attempts</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {tests.map((test, index) => (
                  <tr key={index}>
                    <td>{test.title}</td>
                    <td>{test.sections_count}</td>
                    <td>{test.questions_count}</td>
                    <td>
                    <Link to={`/dashboard?tab=myTest&test_id=${test.id}`}> <button className="btn btn-outline-base btn-sm">View All</button></Link>
                    </td>
                    <td>
                      <Link to={`/test/${test.id}`}>
                        <button className="btn btn-base btn-sm">
                          Attempt New
                        </button>
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {pagination.total_pages > 1 && (
                  <Paginator
                      page={pagination.current_page}
                      rows={pagination.per_page}
                      totalRecords={pagination.total_records}
                      onPageChange={handlePageChange}
                  />
              )}
          </div>
        )}
      </div>
      
    </div>
  );
};

export default AllTests;
